const apis = {
    apiUrl:"https://www.kriyana.com/kriyanamobile_api_jwt/",
    token:"WitrdHBRcmpSMjJ5L3BLa0NITXY1Zz",
    // apiUrl:"http://localhost/ebazar_api_jwt/",
    addressUrl:"Customer/customerAddress",
    saveAddressUrl:"Customer/saveCustomerAddress",
    chooseCity:"SuperAdmin/listCity",
    chooseStoreUrl:"Authenticate/choose_store",
    validateUserMobile:"Authenticate/validateUserMobile",
    sendOtpUrl:"Authenticate/validateUser",
    verifyUrl:"Authenticate/verifyUser",
    verifyMobile:"Authenticate/verifyUserMobile",
    checkUserStores:"Product/checkUserStores",
    mapCustomer:"Product/mapCustomerStores",  //customer_id (encoded)
    updateCustomerName:"Customer/updateCustomerName",  //customer_id (encoded),name (encoded)
    shopkeeperDetails:"SuperAdmin/shopkeeperDetails",
    ordersUrl:"Product/orderDetails",
    moreOrderDetailsUrl:"Product/moreOrderDetails",
    cancelOrderUrl:"Product/orderStatus",
    customerListUrl:"Customer/customerList",
    paymentHistoryUrl:"Product/customerPaymentHistory",
    updateCustomerProfileUrl:"Customer/updateCustomerProfile",
    productListUrl:"Product/productListView",
    top10ProductUrl:"Product/top10Products",
    frequentOrdersUrl:"Customer/frequentCustomerOrder",
    repeatOrderUrl:"Product/repeatOrderMobile",
    productPriceUrl:"Product/productPriceGst",
    wishListUrl:"Product/",
    cartURL:'Product/saveSaleOrderDetails',
    brandsURL:'Product/listBrands',
}

export default{
    data(){
        return{
            apis : apis,
            token:"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdG9yZV9pZCI6IjEiLCJkYiI6ImRlbW8ifQ.Ot0KNi8fe9t3SL9n1k0xbar2umocu0rNbJ3CX2wo05c",
            baseUrl:"https://www.kriyana.com/kriyanamobile_api_jwt/",
            // addressUrl:"Customer/customerAddress",
            // saveAddressUrl:"Customer/saveCustomerAddress",
            // cartURL:'Product/saveSaleOrderDetails',
            // productListUrl:"Product/productListView",
        }
    },
}